import OEmbedParser from './OEmbedParser';
export default (el) => {
    const oEmbedRequestPath =  el.dataset.oembedRequestPath;

    [...el.querySelectorAll('.raw-html-embed')].forEach(raw => {
        if (raw.querySelector('iframe')) {
            raw.classList.add('oEmbedMedia');
            raw.dataset.type = 'video';
        }
    });

    if (!oEmbedRequestPath) {
        console.log('The following element has no/empty data-oembed-request-path', el);
        throw new Error(`No oEmbedRequestPath is provided. Without this you can not fetch oEmbed data from the server`);
    }

    [...el.querySelectorAll('oembed')].forEach(oembed => {
        const oEmbedElement = oembed;
        const options = {
            oEmbedUrl: oembed.getAttribute('url'), // required
            oEmbedRequestPath: oEmbedRequestPath, // required
        };

        new OEmbedParser(oEmbedElement, options);
    });
}
